<template>
  <InnerCardInfo
    v-if="passport_data"
    :label="localStorage.translations.pages['setting-personal_area'].labels['pasport']"
    :images="passport_data.image"
    need-image-domain
    :data="[
      {
        name: localStorage.translations.pages['setting-personal_area'].labels['nomer-pasporta'],
        value: text || '-',
      },
      {
        name: localStorage.translations.pages['setting-personal_area'].labels['srok-deystiviya'],
        value: dateEndFormatted || '-',
      },
    ]"
    ref="inner"
    :editReady="editReady"
  >
    <template slot="edit_block">
      <slot/>
    </template>
  </InnerCardInfo>
</template>

<script>
import InnerCardInfo from './InnerCardInfo'
export default {
  name: 'PassportPdf',
  props: {
    passport_data: Object,
    editReady: Boolean
  },
  components: { InnerCardInfo },
  data: () => ({
    text: null,
    dateEnd: null,
    dateEndFormatted: null,
    dialog: false,
  }),
  watch: {
    passport_data() {
      if (this.passport_data) {
        this.text = this.passport_data.text
        this.dateEnd = this.passport_data.date_end
      }
    },
    dateEnd(val) {
      this.dateEndFormatted = this.formatDate(this.dateEnd)
    },
  },
  mounted() {
    if (this.passport_data) {
      this.text = this.passport_data.text
      this.dateEnd = this.passport_data.date_end
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return (day ? day + '.' : '') + (month ? month + '.' : '') + year
    },
    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
  },
}
</script>
